export const SET_PASSWORD = 'requirePasswordDialogComponent.setPassword'
export const SET_IS_DIALOG_OPEN = 'requirePasswordDialogComponent.setIsDialogOpen'
export const SET_IS_VALID_PASSWORD = 'requirePasswordDialogComponent.setIsValidPassword'

export function setPassword(payload: string) {
  return {
    type: SET_PASSWORD,
    payload
  } as const
}

export function setIsDialogOpen(payload: boolean) {
  return {
    type: SET_IS_DIALOG_OPEN,
    payload
  } as const
}

export function setIsValidPassword(payload: boolean) {
  return {
    type: SET_IS_VALID_PASSWORD,
    payload
  } as const
}

export type RequirePasswordDialogAction = ReturnType<
  typeof setPassword | typeof setIsDialogOpen | typeof setIsValidPassword
>
